<template>
	<section
		id="GlobalNavigationTabs"
		class="view-layout-navigationtabs"
		v-bind:class="{
			'show-captions': showCaptions,
			'show-global-menu': $store.getters.showPrimaryContextMenu,
		}"
		v-on:pointerdown.stop="Handle_OnPointerDown"
	>
		<RouterLink class="tab-item" v-bind:to="{ name: 'PageHome' }" v-if="$feature('nav_feed')">
			<ViewUiIconHome />
			<span class="caption">Feed</span>
		</RouterLink>

		<RouterLink
			class="tab-item"
			v-bind:to="{ name: 'PagePlaces' }"
			v-bind:class="{
				'router-link-exact-active': $route.name === 'PagePlaces' || $route.name === 'PagePlace',
			}"
			v-if="$feature('nav_places')"
		>
			<ViewUiIconPlaces />
			<span class="caption">Places</span>
		</RouterLink>

		<section class="action-container">
			<button
				class="round control size-large type-plus"
				v-bind:class="{
					'theme-dark': $store.getters.showPrimaryContextMenu,
				}"
				v-on:click="Handle_OnClickMenuAction"
			>
				Menu
			</button>
		</section>

		<RouterLink
			class="tab-item"
			v-bind:to="{ name: 'PageTV' }"
			v-bind:class="{
				'router-link-exact-active': $route.name === 'PageTV' || $route.name === 'PageTVSpecific',
			}"
			v-if="$feature('nav_tv')"
		>
			<ViewUiIconTV />
			<span class="caption">TV</span>
		</RouterLink>

		<RouterLink
			class="tab-item"
			v-bind:to="{ name: 'PageExtras' }"
			v-bind:class="{
				'router-link-exact-active': $route.name === 'PageExtras',
			}"
			v-if="$feature('nav_more')"
		>
			<ViewUiIconExtras />
			<span class="caption">More</span>
		</RouterLink>

		<!-- <RouterLink class="tab-item" v-bind:to="{ name: 'PagePad' }">
			<ViewIconPad />
			<span>Pad</span>
		</RouterLink> -->
	</section>
</template>

<script lang="ts">
	import ViewBase from '@/Core/View.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, bind, mounted } from '@/Utility/Decorators';

	/**
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package View/Layout
	 * @project ChalkySticks App
	 */
	@Component
	export default class ViewLayoutNavigationTabs extends ViewBase {
		/**
		 * @type boolean
		 */
		@Prop({ default: false })
		public showCaptions!: boolean;

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * @param PointerEvent e
		 * @return Promise<void>
		 */
		protected async Handle_OnClickMenuAction(e: PointerEvent): Promise<void> {
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();

			this.$store.dispatch('togglePrimaryContextMenu');
		}

		/**
		 * @param PointerEvent e
		 * @return Promise<void>
		 */
		@bind
		protected async Handle_OnPointerDown(e: PointerEvent): Promise<void> {
			e.preventDefault();
			e.stopPropagation();
			e.stopImmediatePropagation();
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	.view-layout-navigationtabs {
		align-items: center;
		background-color: var(--global-tab-background-color);
		bottom: 0;
		box-shadow: 0 -3px 5px rgba(0, 0, 0, 0.05);
		display: flex;
		height: var(--global-tab-height);
		justify-content: center;
		left: 0;
		position: fixed;
		right: 0;
		transition: box-shadow 0.5s ease-in-out, transform 0.3s ease, opacity 0.3s ease;
		z-index: var(--z-header-mid);

		.tab-item {
			border: 0;
			color: var(--tab-inactive-color);
			display: flex;
			flex-direction: column;
			flex: 1;
			font-size: 0.75em;
			font-weight: var(--font-weight-semibold);
			gap: 0.5em;
			text-align: center;
			text-decoration: none;
			text-transform: uppercase;
		}

		.action-container {
			margin: 0 1rem;

			.control {
				outline: 10px solid var(--chalky-blue-4);
				transform: translate(0, -10px);
				transition: background-color 0.25s ease, transform 0.5s ease;
				transition-delay: 0.15s;
			}
		}
	}

	// Variations
	// ---------------------------------------------------------------------------

	#app.state-keyboard .view-layout-navigationtabs {
		display: none;
	}

	// User Interaction
	// ---------------------------------------------------------------------------

	.view-layout-navigationtabs {
		.tab-item:hover {
			color: var(--tab-hover-color);
		}
	}

	// State
	// ---------------------------------------------------------------------------

	.view-layout-navigationtabs {
		.tab-item.router-link-exact-active {
			color: var(--tab-active-color);
		}
	}

	.view-layout-navigationtabs.show-global-menu {
		box-shadow: 0 0 60px rgba(0, 0, 0, 0.5);
		transform: translate(0, calc(-1 * var(--global-action-menu-height)));

		.action-container {
			.control {
				background-color: var(--chalky-blue-2);
				border: 0;
				color: var(--color-white);
				transform: translate(0, -10px) rotate(135deg);
				transform-origin: center center;
			}
		}
	}

	.view-layout-navigationtabs:not(.show-captions) {
		.tab-item .caption {
			display: none;
		}
	}
</style>
